module.exports = __webpack_public_path__ + "img/5f5b188.jpg";